export default () => ({
  show: false,
  error: null,
  wishlist: [],
  productList: [],
  wishCount: 0,
  totalAmount: 0,

  toggle() {
    this.show = !this.show;
    Grebify.noScroll(!this.show);
  },

  setProduct(event) {
    const wishlist = this.getWishlistFromLocalStorage();
    const foilData = this.getFoilDataFromLocalStorage();
    const existingItem = this.findWishlistItem(
      wishlist,
      event.detail.productId,
      event.detail.variantId
    );

    if (existingItem) {
      this.increaseProductQuantity(existingItem);
    } else {
      this.addNewProductToWishlist(
        wishlist,
        event.detail.handle,
        event.detail.productId,
        event.detail.variantId,
        foilData[0]?.data
      );
    }

    this.updateWishlistInLocalStorage(wishlist);
    this.updateWishCount();
    this.loadWishlist();
    this.toggle();

    // Assuming "foil" is just a part of the item data, no need to remove it
    localStorage.removeItem("foil"); // If this is no longer needed
  },

  fetchProductDetails(handle, variantId) {
    const url = `${Shopify.routes.root}products/${handle}.js`;

    return fetch(url)
      .then((response) => this.handleFetchResponse(response))
      .then((product) => this.getProductVariant(product, variantId))
      .catch((error) => this.handleFetchError(error));
  },

  loadWishlist() {
    const wishlist = this.getWishlistFromLocalStorage();
    this.wishlist = wishlist;
    this.productList = [];
    this.totalAmount = 0;

    wishlist.forEach((item) => {
      this.fetchProductDetails(item.handle, item.variantId).then(
        ({ product, variant }) => {
          if (product && variant) {
            this.addProductToList(item, product, variant, item.foil);
          }
        }
      );
    });
    this.updateWishCount();
  },

  removeFromWishlist(productId, variantId) {
    const wishlist = this.getWishlistFromLocalStorage();
    const index = this.findWishlistItemIndex(wishlist, productId, variantId);

    if (index !== -1) {
      wishlist.splice(index, 1)[0];
      this.updateWishlistInLocalStorage(wishlist);
      this.updateWishCount();
      this.loadWishlist();
    }
  },

  init() {
    this.loadWishlist();
  },

  // Helper functions
  getWishlistFromLocalStorage() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  },
  getFoilDataFromLocalStorage() {
    return JSON.parse(localStorage.getItem("foil")) || [];
  },

  updateWishlistInLocalStorage(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  },

  findWishlistItem(wishlist, productId, variantId) {
    return wishlist.find(
      (item) => item.productId === productId && item.variantId === variantId
    );
  },

  findWishlistItemIndex(wishlist, productId, variantId) {
    return wishlist.findIndex(
      (item) => item.productId === productId && item.variantId === variantId
    );
  },

  increaseProductQuantity(item) {
    item.quantity += 1;
  },

  addNewProductToWishlist(wishlist, handle, productId, variantId, foil) {
    wishlist.push({ handle, productId, variantId, quantity: 1, foil });
  },

  handleFetchResponse(response) {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  },

  getProductVariant(product, variantId) {
    const variant = product.variants.find((v) => v.id == variantId);
    return { product, variant };
  },

  handleFetchError(error) {
    this.error = error;
    console.error("There has been a problem with your fetch operation:", error);
  },

  addProductToList(item, product, variant, foil) {
    const totalPrice = (variant.price * item.quantity) / 100;
    this.productList.push({ ...item, product, variant, totalPrice, foil });
    this.totalAmount += totalPrice;
  },

  updateWishCount() {
    this.wishCount = this.wishlist.reduce(
      (total, item) => total + item.quantity,
      0
    );
  },
});
